/**
 * Frequency-aware population prompt copy for Test Run scoping.
 * Static template (no AI) keyed off frequency + data source + control noun.
 */
export function populationPrompt(control, periodLabel) {
  const freq = String(control?.frequency || '').toLowerCase();
  const source = control?.data_source || control?.data_source_type || control?.system || 'the source system';
  const noun = control?.population_noun || 'transactions';
  const period = periodLabel || 'the selected date range';

  const transactional = ['event-based', 'daily', 'weekly', 'bi-weekly', 'semi-monthly', 'monthly'].includes(freq);
  if (transactional) {
    return `This is a transactional '${control?.frequency || 'recurring'}' control utilizing ${source}. ` +
      `Please upload the complete, unfiltered population extraction of all ${noun} generated within ${period}.`;
  }
  return `Upload the population / universe of items for this control covering ${period} ` +
    `(from ${source}), so a representative sample can be selected.`;
}
